import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    ...shorthands.padding("16px", "16px", "16px", "0px"), // Removed left padding to align with page
    ...shorthands.gap("6px"),
    alignItems: "center",
  },
  icon: {
    height: "20px",
    width: "20px",
  },
});
